import 'slick-carousel';

const sliderInitial = '.slick-slider-features';
const sliderSelector = '.js-slider-features';
const sliderDotsSelector = `${sliderSelector} .slider__dots`;

/**
 * Slide testimonial
 */
 $(sliderInitial).slick({
 	arrows: false,
 	dots: true,
 	infinite: false,
 	speed: 600,
 	slidesToShow: 3,
 	slidesToScroll: 3,
 	appendDots: $(sliderDotsSelector),
 	responsive: [
	{
 		breakpoint: 768,
 		settings: {
		 	vertical: true,
		}
 	}]
 });